// import { Worker, Viewer } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';

// const PDFViewer = ({ pdfPath }) => {
//     return (
//         <div className="w-full rounded-md bg-white">
//             <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js`}>
//                 <div className="w-full py-7" style={{ height: '100vh' }}>
//                     <Viewer fileUrl={pdfPath} />
//                 </div>
//             </Worker>  
//         </div>
//     );
// };

// export default PDFViewer;


function PdfViewer({ pdfPath }) {
    const viewerUrl = `https://docs.google.com/viewer?url=${pdfPath}&embedded=true`;
    return (
        <iframe
            src={viewerUrl}
            width="100%"
            height="780"
            style={{ border: 'none' }}
            title="PDF Viewer"
        ></iframe>
    );
}

export default PdfViewer;
